// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "lead".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { allLeadStatusValues, consentSourceValues, leadMarketingBasisValues, leadSourceValues } from '@borradh-workspace/labels';
/** Response atom for the "lead" table (1:1 with a DB row, on the wire). */
export const leadAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    firstName: z.string(),
    lastName: z.string().nullable(),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    whatsapp: z.string().nullable(),
    source: z.enum(leadSourceValues),
    status: z.enum(allLeadStatusValues),
    facebookLeadId: z.string().nullable(),
    psid: z.string().nullable(),
    formData: z.unknown().nullable(),
    sequenceId: z.string().nullable(),
    sequenceStatus: z.string().nullable(),
    currentStepId: z.string().nullable(),
    sequenceStartedAt: z.string().datetime().nullable(),
    nextActionAt: z.string().datetime().nullable(),
    assignedToId: z.string().nullable(),
    primaryLocationId: z.string().nullable(),
    tags: z.array(z.string()).nullable(),
    notes: z.string().nullable(),
    portalNote: z.string().nullable(),
    metadata: z.unknown().nullable(),
    humanTakeoverRequested: z.boolean().nullable(),
    humanTakeoverReason: z.string().nullable(),
    humanTakeoverAt: z.string().datetime().nullable(),
    consentEmail: z.boolean(),
    consentSms: z.boolean(),
    consentSmsMarketing: z.boolean(),
    consentWhatsapp: z.boolean(),
    consentVoice: z.boolean(),
    consentSource: z.enum(consentSourceValues).nullable(),
    consentedAt: z.string().datetime().nullable(),
    marketingBasis: z.enum(leadMarketingBasisValues),
    marketingBasisAt: z.string().datetime().nullable(),
    micrositeId: z.string().nullable(),
    utmSource: z.string().nullable(),
    utmMedium: z.string().nullable(),
    utmCampaign: z.string().nullable(),
    utmContent: z.string().nullable(),
    utmTerm: z.string().nullable(),
    lastContactedAt: z.string().datetime().nullable(),
    convertedAt: z.string().datetime().nullable(),
    lastVisitAt: z.string().datetime().nullable(),
    lifetimeSpendCents: z.number(),
    listRank: z.number().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    deletedAt: z.string().datetime().nullable(),
    privacyErasedAt: z.string().datetime().nullable(),
});
//# sourceMappingURL=lead.js.map